import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { dashboardDataApi } from '../../api';
import KpiGrid from './KpiGrid';
import RevenueChart from './RevenueChart';

const Dashboard = () => {
  const token = useSelector((state) => state?.user?.user?.token);

  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await dashboardDataApi({ token, filter: 'week' });
        setDashboardData(response);
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
        toast.error(error?.error || 'Failed to fetch dashboard data');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [token]);

  return (
    <div style={{ maxWidth: '1520px', width: '100%' }}>
      <KpiGrid data={dashboardData} loading={loading} />
      <RevenueChart data={dashboardData?.revenueData} loading={loading} />
    </div>
  );
};

export default Dashboard;
